(function () {
  var productPath = /^\/products\//;

  function syncOpenGraphType() {
    var meta = document.head.querySelector('meta[property="og:type"]');
    if (!meta) return;

    var desired = productPath.test(window.location.pathname) ? 'product' : 'website';
    if (meta.getAttribute('content') !== desired) {
      meta.setAttribute('content', desired);
    }
  }

  function syncRobots() {
    var meta = document.head.querySelector('meta[name="robots"]');
    if (!meta) return;

    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    if (/^\/collections\/[^/]+$/.test(path)) {
      meta.setAttribute('content', 'index,follow');
    }
  }

  function syncSiteSchema() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    var canonical = document.head.querySelector('link[rel="canonical"]');
    var pageUrl = canonical && canonical.href ? canonical.href : window.location.href;
    var siteUrl = new URL(pageUrl, window.location.origin).origin + '/';
    var pageTitle = document.title || 'Sabunal | Doğal Bakım ve Ürünler';
    var description = document.head.querySelector('meta[name="description"]');
    var pageType = 'WebPage';
    var utilityPage = /^\/(urun-arama|sepet|cart|hesabim)(\/|$)/.test(path);
    var schema = document.getElementById('sabunal-site-schema');
    if (!schema) {
      schema = document.createElement('script');
      schema.id = 'sabunal-site-schema';
      schema.type = 'application/ld+json';
      document.head.appendChild(schema);
    }

    var graph = [
      {
        '@type': 'Organization',
        '@id': siteUrl + '#organization',
        name: 'Sabunal',
        url: siteUrl
      },
      {
        '@type': 'WebSite',
        '@id': siteUrl + '#website',
        url: siteUrl,
        name: 'Sabunal',
        publisher: { '@id': siteUrl + '#organization' },
        inLanguage: 'tr'
      }
    ];

    if (!utilityPage) {
      graph.push({
        '@type': pageType,
        '@id': pageUrl.split('#')[0] + '#webpage',
        url: pageUrl,
        name: pageTitle,
        description: description ? description.getAttribute('content') || '' : '',
        isPartOf: { '@id': siteUrl + '#website' },
        about: { '@id': siteUrl + '#organization' },
        inLanguage: 'tr'
      });
    }

    schema.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': graph });
  }

  function syncRouteSeo() {
    syncOpenGraphType();
    syncRobots();
    window.setTimeout(syncSiteSchema, 0);
    window.setTimeout(syncSiteSchema, 120);
    window.setTimeout(syncSiteSchema, 500);
  }

  var originalPushState = window.history.pushState;
  window.history.pushState = function (state, title, url) {
    if (url != null) {
      var target = new URL(String(url), window.location.href);
      var isNativeProductRoute = target.origin === window.location.origin
        && /^\/products\/[^/]+\/?$/.test(target.pathname);

      if (isNativeProductRoute) {
        window.location.assign(target.pathname + target.search + target.hash);
        return;
      }
    }

    var result = originalPushState.apply(this, arguments);
    syncRouteSeo();
    return result;
  };

  window.addEventListener('popstate', syncRouteSeo);
  syncRouteSeo();

  var observer = new MutationObserver(function () {
    syncOpenGraphType();
    syncRobots();
  });
  observer.observe(document.head, { attributes: true, childList: true, subtree: true });
})();
